import Image from 'next/image';
import React from 'react';
import FadeInAnimation from "../../Common/FadeInAnimation";
import { useTranslations } from '../../../locales/useTranslations';
import { BiLogoWordpress, BiCodeAlt, BiShield, BiRocket } from 'react-icons/bi';
import Link from 'next/link';

const WordpressBetreuungHeader = () => {
    const { t } = useTranslations();

    return (
        <div className="mainbanner wp-header">
            {/* Subtile Hintergrund-Elemente */}
            <div className="wp-header__decoration wp-header__decoration--top"></div>
            <div className="wp-header__decoration wp-header__decoration--bottom"></div>

            <section className="services-area ptb-100 wp-header__section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12">
                            <div className="services-content it-service-content">
                                <div className="content">
                                    <div className="wp-header__badge">
                                        {t('wordpressSupport_header_upperTitle')}
                                    </div>

                                    <h1 className="wp-header__title">
                                        {t('wordpressSupport_header_title')}
                                    </h1>

                                    <p className="wp-header__description">
                                        {t('wordpressSupport_header_description')}
                                    </p>

                                    <p className="wp-header__description wp-header__description--secondary">
                                        {t('wordpressSupport_header_description2')}
                                    </p>

                                    {/* Feature-Karten */}
                                    <div className="row wp-header__features-row">
                                        <div className="col-md-6 mb-3">
                                            <div className="wp-header__feature-card">
                                                <BiShield className="wp-header__feature-icon" />
                                                <h4 className="wp-header__feature-title">
                                                    {t('wordpressSupport_header_security')}
                                                </h4>
                                                <p className="wp-header__feature-text">
                                                    {t('wordpressSupport_header_security_desc')}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <div className="wp-header__feature-card">
                                                <BiRocket className="wp-header__feature-icon" />
                                                <h4 className="wp-header__feature-title">
                                                    {t('wordpressSupport_header_performance')}
                                                </h4>
                                                <p className="wp-header__feature-text">
                                                    {t('wordpressSupport_header_performance_desc')}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* CTA Button */}
                                    <Link href="/kontakt" className="wp-header__cta">
                                        <BiLogoWordpress style={{ marginRight: '8px' }} />
                                        {t('wordpressSupport_header_cta')}
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-12">
                            <div className="services-image wp-header__image-wrapper">
                                <FadeInAnimation direction="right" delay={100}>
                                    <div className="image wp-header__image-card">
                                        {/* Dekorative Elemente */}
                                        <div className="wp-header__image-decoration"></div>

                                        <div className="wp-header__image-content">
                                            <Image
                                                src="/images/web-development/wordpress.webp"
                                                alt="Simplify Data - Wordpress Betreuung"
                                                width={0}
                                                height={0}
                                                sizes="100vw"
                                                className="wp-header__main-image"
                                            />
                                            <h3 className="wp-header__image-title">
                                                {t('wordpressSupport_header_title')}
                                            </h3>
                                            <p className="wp-header__image-subtitle">
                                                {t("wordpressSupport_header_subtitle_image")}
                                            </p>

                                            <div className="wp-header__icon-badges">
                                                <div className="wp-header__icon-badge">
                                                    <BiCodeAlt className="wp-header__icon-badge-icon" />
                                                </div>
                                                <div className="wp-header__icon-badge">
                                                    <BiShield className="wp-header__icon-badge-icon" />
                                                </div>
                                                <div className="wp-header__icon-badge">
                                                    <BiRocket className="wp-header__icon-badge-icon" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </FadeInAnimation>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default WordpressBetreuungHeader;
